import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { withActionsExecutor, ActionsExecutorPropsType } from "components/actions";
import { Grid } from "components/controls/widget";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import PageContent from "common/web/PageContent";
import { RouteProps } from "./routes-path";
import { FormDecorated, apiGetSpecificationsDecoratedForMember } from "common/api/Forms";
import SeznamItem from "./SeznamItem";
import { Typography } from "@material-ui/core";

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    seznam: FormDecorated[];
}


type SeznamProps = RouteComponentProps<RouteProps>;

type PropsType = SeznamProps & State & ActionsExecutorPropsType & WithStyles<typeof styles>;

const initialState: State = {
    loading: true,
    hasError: false,
    seznam: [],
}

class Seznam extends React.PureComponent<PropsType> {

    loadContent = (idtClena: string) => {

        const { executeAction, updateState } = this.props;

        const action = apiGetSpecificationsDecoratedForMember(idtClena)
            .onSuccess(d => {
                updateState({ loading: false, seznam: d });
            })
            .onError(e => {
                const errMessage = e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false, seznam: [] });
    }

    componentDidMount() {
        const { idtClena } = this.props.match.params
        this.loadContent(idtClena);
    }

    render() {
        const { seznam, loading, hasError, error, classes } = this.props;
        const { idtClena } = this.props.match.params

        return <PageContent titles={['Ankety a hlasování']}>
            {loading
                ? <Loading loading={loading} color="primary" />
                : hasError
                    ? <Error>{error}</Error>
                    : <div>
                        <Grid container spacing={24} direction="column" className={classes.itemsContainer}>
                            {seznam.length == 0 ? <Grid>
                                <Typography variant="h6" align="center">{'Momentálně tu pro Vás není žádná anketa nebo hlasování.'}</Typography>
                            </Grid>
                                : seznam.map((i, k) => <Grid key={i.id} item>
                                    <SeznamItem item={i} idtClena={Number(idtClena)} />
                                </Grid>)}
                        </Grid>
                    </div>
            }</PageContent>;

    }
}


const styles = (theme: Theme) => createStyles({
    itemsContainer: {
        padding: 2 * theme.spacing.unit,
    },

    buttonLabel: {
        display: 'inline'
    }

});

export default withStyles(styles)(withRouter(withActionsExecutor<SeznamProps, State>(initialState, Seznam)));